angular.module('rjmNg.directives').directive 'ceColumn', [
  "$rootScope"
  ($rootScope) ->
    restrict:"E"
    templateUrl: "directive.ceColumn.html"
    priority: 200
    scope:
      table: '='
      column: '='
      allowRemoval: '='
      removeHandler: '='
    replace: true
    require: "^?rjmUi"
    controllerAs: "view"
    bindToController: true
    controller: [
      "StructureCache"
      "notification"
      "rjdl"
      "rjdlDefinitionInjector"
      "referenceService"
      "utils"
      "$modal"
      "app"
      "$timeout"
      (
        StructureCache
        notification
        rjdl
        rjdlDefinitionInjector
        referenceService
        utils
        $modal
        app
        $timeout
      ) ->
        view = @

        view.converter = null
        view.subitem = null
        view.definitionType = null
        view.definitionSpec = null
        view.selectedPath = null
        view.canAddFilters = false
        view.loading = true

        view.structure = null

        # Only show filter sets whose tableId is in this list
        view.tableIds = []
        view.filterSetWarning = null
        view.restrictionSetColumns = null
        view.referenceToLocalTable = false
        view.rjqlSvcClient = app.hasFeatureFlag('RJQL_SERVICE_CLIENT')

        view.allOptions =
          filter_set:
            name: 'Filters'
            iconClass: 'filter'

        _excludeDefinition = (list, definition, category) ->
          list.map (listItem) ->
            if listItem.id is category
              listItem.definitions = listItem.definitions.filter (defItem) ->
                defItem.definition isnt definition
            listItem

        _hasAccess = (ff) ->
          view.rjqlSvcClient \
            and (app.hasFeatureFlag(ff) or app.isSupportUserSession())

        _getDefinitionList = () ->
          # Remove beta derivatives from UI unless we have the proper flags
          list = rjdl.getDefinitionList()
          unless _hasAccess('RJQL_SERVICE_CLIENT')
            list = _excludeDefinition(list, "calculation", "sameTable")
            list = _excludeDefinition(list, "date_diff", "sameTable")
            list = _excludeDefinition(list, "sequence", "sameTable")
            list = _excludeDefinition(list, "sequential_comparison", "sameTable")
            list = _excludeDefinition(list, "currency_converter", "sameTable")
          return list

        _updateFiltersAvailability = () ->
          view.canAddFilters = view.converter?.filtersSupported and
            not view.column.filter_set?

        _updateRestrictionSetColumns = () ->
          unless view.structure?
            return

          unless view.tableIds.length > 0
            view.restrictionSetColumns = []
            return

          view.restrictionSetColumns = _.chain view.tableIds
            .map (tableId) -> view.structure.tables[tableId].columns
            .flatten()
            .map (column) ->
              tableName = view.structure.tables[column.table_id].name

              name: "#{tableName}.#{column.name}"
              column_id: column.id
              datatype: column.old_data_type
            .value()

        _shouldDeleteFilterSet = () ->
          filterSetIsSet = view.column?.filter_set?
          filtersSupported = view.converter?.filtersSupported

          return filterSetIsSet and not filtersSupported

        view.addFilter = () ->
          emptyRestrictionSet =
            restrictions: []
            sequence:
              errorMessage: null
              string: null
          view.column.filter_set = utils.copy(emptyRestrictionSet)
          _updateFiltersAvailability()

        view.getStructure = () ->
          StructureCache.getStructureAndReferences().then(
            (result) ->
              view.structure = result.structure
              StructureCache.getReferences().then( (result) ->
                view.allReferences = result.references
                view.updateReferences()
                _updateRestrictionSetColumns()
                view.loading = false
              , (error) ->
                notification.error("Server Error", "Error loading structure/references.", "data-warehouse-notifications", error)
                view.loading = false
              )
          )

        view.updateReferences = () ->
          if view.allReferences? and view.converter?
            view.references = referenceService.filter(
              view.allReferences,
              view.table,
              view.column,
              view.converter.validateReference
            )

        view.showReference = (definition) ->
          view.converter?.arg is 'tableColumn'

        # Checks the column type, but doesn't mess with our values
        view.updateDefinitionProperties = () ->
          if view.column?.definition?
            view.converter =
              rjdlDefinitionInjector.getConverterForType(view.column.definition)
          else
            view.converter = null

          if view.converter?
            view.subitem =
              rjdl.getSubitem(view.converter, view.column.subtype)
          else
            view.subitem = null

          if view.subitem?.arg?
            view.arg = view.subitem.arg
          else
            view.arg = view.converter?.arg

          # Remove any filters if not applicable for this column type
          if _shouldDeleteFilterSet()
            delete(view.column.filter_set)

          view.hasSecondArgument = view.column?.definition is "date_diff"

          _updateFiltersAvailability()

        view.resetTableAndColumnReferences = () ->
          return unless view.column?.attrs?.ref?

          view.setTableReferences()

          view.column.attrs.ref.column = null

        view.setTableReferences = () ->
          view.column.attrs.ref.table = switch
            when view.converter?.arg is 'column' then view.table
            when view.selectedPath? and view.definitionType.id is 'manyToOne' then view.selectedPath.from.table
            when view.selectedPath? and view.definitionType.id is 'oneToMany' then view.selectedPath.to.table
            else null

        # Determine whether we need to reset the table and column, which is
        # required when the definition changes, but not when the column changes.
        view.canSkipReset = (column, old) ->
          return true unless not angular.equals(column, old)

          columnIdSet = column?.id? and column.id isnt 0
          oldColumnIdSet = old?.id? and old.id isnt 0

          column? isnt old? or # column went from being null to non-null or vice-versa
            (columnIdSet isnt oldColumnIdSet) or # went from editing an existing column to a new column or vice-versa
            (columnIdSet and column.id isnt old.id) # went from editing an existing column to a different existing column

        view.removeFilter = () ->
          delete(view.column.filter_set)
          _updateFiltersAvailability()

        # Set the tableIds used to filter the list of filter sets. The list
        # should contain filter sets associated with the current table, plus
        # the reference table, if applicable.
        view.updateFilterSetState = () ->
          if view.table and view.converter?.filtersSupported
            filterSetProperties = view.converter.getFilterSetProperties(
              view.table
              view.column
            )

            view.tableIds = filterSetProperties.tableIds
            view.filterSetWarning = filterSetProperties.warning

            if filterSetProperties.referenceToLocalTable?
              view.referenceToLocalTable = filterSetProperties.referenceToLocalTable
            else
              view.referenceToLocalTable = false

          else
            view.tableIds = []
            view.filterSetWarning = null
            view.referenceToLocalTable = false

          _updateRestrictionSetColumns()

        view.updatePathsState = () ->
          view.selectedPath = view.column.attrs?.reference
          view.tablePathDirection = switch
            when view.definitionType?.id is "manyToOne" then "to"
            else "from"

        view.launchReferencesModal = () ->
          referenceScope = $rootScope.$new()
          referenceScope.tableId = view.table
          referenceScope.referenceToLocalTable = view.referenceToLocalTable

          modal = $modal
            template: 'modal.references.html'
            show: true
            backdrop: 'static'
            scope: referenceScope
            modalClass: 'wideModal'

        _makeContextName = (type, subtype) ->
          mainContextName = "column-editor"
          # for batcheetah clients we want to show a different help context
          # because their only choice at this step is AGE
          if type is "sameTable" and not view.rjqlSvcClient
            mainContextName = "batcheetah-#{mainContextName}"

          if type? and subtype?
            "#{mainContextName}-#{type}-#{subtype}"
          else if type? and not subtype?
            "#{mainContextName}-#{type}"
          else
            mainContextName

        view.setDefinitionEquation = (type) ->
          view.column.definition = type.definition
          view.column.subtype = type.subtype
          view.selectedPath = null
          view.column.attrs.reference = null
          view.removeFilter()
          $rootScope.$broadcast "updateHelpContext", _makeContextName(type.definition, type.subtype)

        view.setDefinitionType = (category) ->
          view.definitionType = category
          view.column.definition = null
          view.column.subtype = null
          $rootScope.$broadcast "updateHelpContext", _makeContextName(category.id)

        view.updateDefinitionSpec = () ->
          view.definitionSpec =
            rjdl.getPropertiesForDefinition(view.column.definition, view.column.subtype)

          if view.definitionSpec?
            view.definitionType = view.definitionsByCategory.filter(
              (definition) ->
                definition.id is view.definitionSpec.category
            )[0]

        view.allowsColumnSelection = () ->
          view.arg in ['tableColumn', 'column']

        view.showHelpLink = () ->
          return view.definitionSpec?.helpLink?

        @$onInit = () ->
          view.getStructure()
          view.definitionsByCategory = _getDefinitionList()
          $timeout ->
            $rootScope.$broadcast "updateHelpContext", _makeContextName()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      view = scope.view

      scope.$watch 'view.selectedPath', (path) ->
        if path?
          view.setTableReferences()
          view.column.attrs.reference = path

      scope.$watch 'view.column.definition', (definition) ->
        view.updateDefinitionSpec()

      scope.$watch 'view.column.subtype', (subtype) ->
        view.updateDefinitionSpec()

      scope.$watch 'view.column', (column, old) ->

        if view.canSkipReset(column, old) # A new column has been loaded
          view.updateDefinitionProperties()
          view.updateFilterSetState()
          view.updatePathsState()
        else if column.definition isnt old.definition or column.subtype isnt old.subtype # We're editing a previously-loaded column
          view.updateDefinitionProperties()
          view.resetTableAndColumnReferences()
          view.updateFilterSetState()
          view.updatePathsState()
        # Reference path has changed
        else if column.attrs.ref.table isnt old.attrs.ref.table
          view.resetTableAndColumnReferences()
          view.updateFilterSetState()

        view.updateReferences()
      , true

      # If anyone has updated the structure, we need to refresh this
      scope.$on 'structureCacheUpdated', () ->
        view.getStructure()

      scope.$on 'showReferenceEditor', () ->
        view.launchReferencesModal()

      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "data-warehouse", view.loading

]
